<template>
    <div class="container">

      <div id="title">Content Moderation</div>
      <div class="input-container">
        <label for="textInput" style="font-size: 20pt;font-weight: Normal;color:rgb(46, 46, 46)">
        Type your text here:</label>
        <input type="text" v-model="inputText" id="textInput" class="input-text" @click="clear">
        <!-- <button @click="callAPI" class="submit-btn">Submit</button> -->
        <div class="button-container">
          <v-btn @click="callAPI" sblock rounded="lg" size="x-large" color="#0a6aab" class="submit-btn">Submit</v-btn>
          <v-btn @click="clear" sblock rounded="lg" size="x-large" color="#0a6aab" class="submit-btn">Clear</v-btn>
        </div>
        
      </div>
      <p style="font-size: 8pt;color:rgb(158, 158, 160);;">
        Please press "Clear" Button before trying another sentence</p>
      <div class="output-container">
        <h3 style="font-size: 15pt;font-weight: normal;color:rgb(46, 46, 46)">Input Text:</h3>
        <p style="font-size: 12pt;color:rgb(23, 76, 192);background-color: rgb(244, 241, 241);">{{ inputText }}</p>
        <h3 style="font-size: 15pt;font-weight: normal;color:rgb(46, 46, 46)">Output:</h3>
        <!-- <p>{{ output }}</p> -->
        <div class="tag-container">
          <div class="tag" v-for="tag in tags" :key="tag.id" :class="tag.className" 
          :style="{backgroundColor: tag.color}">{{ tag.name }} </div>
        </div>
      </div>
    </div>
  </template>
  
<script>

import axios from "axios";

axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
axios.defaults.withCredentials = false;
  
export default {
name: "ContentModeration",
data() {
    return {
    inputText: '',
    output: '----',
    api_url: "https://fallback-server-for-on-browser.privately.swiss:8082",
    tags: [
      { id: 1, name: 'Toxic', className: 'toxic', color: '#808080'},
      { id: 2, name: 'Insult', className: 'insult', color: '#808080'},
      { id: 3, name: 'Threat', className: 'threat', color: '#808080'},
      { id: 4, name: 'Sexual', className: 'sexual', color: '#808080' },
      { id: 5, name: 'Identity', className: 'identity', color: '#808080' }
    ],
    labels:{toxic:'toxicity',insult:'insult',threat:'threat',sexual:"sexual_explicit",identity:"identity_attack"}
    }
},
methods: {
  clear(){
    for(let key in this.labels){
      this.tags.find(tag => tag.className === key).color = '#808080';
    }
    this.inputText='';
  },
  settags(key,value){
    if (value > 0.5){
      this.tags.find(tag => tag.className === key).color = '#4CAF50';
    }
    else{
      this.tags.find(tag => tag.className === key).color = '#808080';
    }
  },
  callAPI() {
      const apiUrl = this.api_url + "/api/toxicity_max"; // Replace with your API endpoint

      axios.post(apiUrl, {
        input_text: this.inputText
      })
      .then(response => {
        this.output = response.data; // Assuming the response has a 'result' field
        // console.log(this.output)
        for(let key in this.labels){
          // console.log(key)
          this.settags(key,parseFloat(this.output[this.labels[key]]))
        }
      })
      .catch(error => {
        console.error('There was a problem with the API call:', error);
        this.output = 'Error: ' + error.message;
      });
    }
  

  }
};
</script>

<style scoped>
#title{
  font-weight: bold;
  font-size: 25pt;
  color: white;
  margin-bottom: 20px;
  background-color:#0a6aab ;
  border: 5px solid #0a6aab;
  border-radius: 4px;
  display: block;

}
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* height: 100vh; */
}

.input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.input-text {
  width: 500px;
  padding: 8px;
  margin-bottom: 30px;
  border: 1px solid #ccc;
  border-radius: 4px;
  outline: none;
  transition: box-shadow 0.3s ease; /* Adding transition effect */
  resize: vertical; /* Allowing vertical resizing */
  overflow: auto; /* Show scrollbar if content exceeds */
  word-wrap: break-word; /* Allowing word wrapping */
  height: 60px;
  white-space: normal;
}
.button-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.submit-btn {
  /* padding: 8px 20px; */
  /* color: #14C6FF; */
  display: inline-block;
  background-color: #0a6aab;
  color: white;
  border: none;
  cursor: pointer;
}

.output-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  border-top: 1px solid #ccc;
  padding-top: 20px;
}

.output-container h3 {
  margin-bottom: 5px;
}

.tag {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 5px;
  color: white;
  font-weight: bold;
}

</style>
  